export default __webpack_public_path__ + "static/media/dental.320f66d8.svg";